export default "__VITE_ASSET__CAmvSD15__"